<template>
  <kst-section :title="Info.Section.TransactionSetting.Title">
    <kst-output field="BackDateInterval" :data="details.Access" :catalog="Catalog">
      <template #right>
        <div class="control">
          <div class="input ks-output" readonly>
            {{ Info.Field.BackDateInterval.Suffix }}
          </div>
        </div>
      </template>
    </kst-output>
  </kst-section>
</template>

<script>
import Catalog from "../UserCatalog.js";
import Info from "../UserInfo.js";

export default {
  props: {
    details: Object
  },
  data: () => ({
    Catalog: Catalog,
    Info: Info,
  })
}
</script>